const CommonLanding = ({ mdName, image, video, title1, bgcolor, title2, title3, headingTitle, content, content1, overlay = false }) => {
  return (
    <section id="common-page">
      <section className="landing">
        <div
          className="img cover-img"
          style={{
            backgroundColor: bgcolor,
            position: "relative",
            overflow: "hidden",
            width: '100%',
            height: "100vh", /* Full screen */
          }}
        >
          {video ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                zIndex: 0,
                pointerEvents: "none", // Prevent interaction on iOS
              }}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : image ? (
            <div
              className="baackground"
              style={{
                backgroundImage: `url(${image})`,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                 zIndex: 0,
              }}
            >
              {/* {overlay && (
                <div
                  className="overlay"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    zIndex: 1,
                  }}
                ></div>
              )} */}
            </div>
          ) : null}

          <div
            className="container"
            style={{
              position: "relative",
              zIndex: 2,
            }}
          >
            <div className="txt flex center-left">
              <div className="col-4-5">
                <div className="l-h-1">
                  <h5 className="font-barlow f-w-300">{headingTitle}</h5>
                  <br />
                  <h4 className="font-barlow f-w-300">{title1}</h4>
                  <h4 className="font-barlow t-t-u f-w-300">{title2}</h4>
                  <h4 className="font-barlow t-t-u f-w-300">{title3}</h4>
                  <h6 className="font-barlow t-t-u f-w-300 p-42 color-blue2">{mdName}</h6>
                </div>
                <br />
                <p className="p-18 l-h-1-2 font-nunito-sans font-w-400 width-para" style={{ width: "90%" }}>
                  {content}
                </p>
                <p className="p-18 l-h-1-2 font-nunito-sans font-w-400 width-para" style={{ width: "70%" }}>
                  {content1}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default CommonLanding;
